<template>
  <div class="content if-profile">
    <MPHeader :headerData="this.headerData" />
    <div class="md-layout ratios-report">
      <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item md-medium-size-70 md-xsmall-size-100 md-size-70 p-0">
            <h4>Industry Market Profile</h4>
            <ul>
              <li>
                <h6><i class="md-icon">business_center</i>Industry:</h6>
                <p>[{{ parseInt(this.bznaics_code) }}] {{ this.industry_title }}</p>
              </li>
              <li>
                <h6><i class="md-icon">business</i>Sector:</h6>
                <p>{{ this.sector_name }}</p>
              </li>
              <li>
                <h6><i class="md-icon">place</i>Market Area:</h6>
                <p>{{ this.display_area }}</p>
              </li>
            </ul>
          </div>
          <div class="md-layout-item md-medium-size-30 md-size-30 button-box">
            <md-button class="md-info pdf_btn access-button" :href="'/'" target="_blank"><md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF</md-button>
            <md-button class="md-info csv_btn access-button" v-on:click="downloadCSVData"><md-icon class="ml-5">receipt_long</md-icon>Download CSV</md-button>
          </div>
        </div>
      </div>-->

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">COVID-19 Impact</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>What are the average annual sales of all industry sites, small businesses and startups in this market?
                 Median sales are also displayed to avoid distortion of averages by unusually large firms. If you made the
                necessary inputs, your firm sales are benchmarked.<br><br>
                Small business sales represent firms with 25 employees. Startup sales are calculated for firms in operation for less than two years.<br><br>
                Market volume and average firm sales calculations are developed with firm‐level data which is integrated with Bizminer
                internally generated Sales per Employee projections. SPE data is both industry‐ and location‐specific, and is updated
                monthly by the application of US Census data and five industry and consumer price and productivity indices from the
                Bureau of Labor Statistics and other federal agencies.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>help</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="md-transparent finanical-report-messages">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 p-0">
                  <md-card class="if_card">
                    <md-card-header>COVID-19 Impact</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100  blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Month-to-Month
                                  Employment (Dec-19={{
                                  newCovid['Dec']&&newCovid['Dec']['19']?newCovid['Dec']['19'].Employment:''}})
                                </div>
                              </h4>
                              <!-- <h4 class="title text-left">Month-to-Month Employment-Sales</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumns" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovid" :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumns" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumns[index]] ?
                                        element[yearsCovidColumns[index]].Employment:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-size-100  blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Month-to-Month
                                  Sales
                                  (Dec-19={{newCovid['Dec']&&newCovid['Dec']['19']?newCovid['Dec']['19'].Sales:''}})
                                </div>
                              </h4>
                              <!-- <h4 class="title text-left">Month-to-Month Employment-Sales</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumns" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovid" :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumns" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumns[index]] ? element[yearsCovidColumns[index]].Sales:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-size-100 blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header class="md-card-header-icon">
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">% Change from
                                  Dec-19 Employment
                                  (Dec-19={{ newCovidChange['Dec'] &&
                                  newCovidChange['Dec']['19']?newCovidChange['Dec']['19'].Employment:''}})
                                </div>
                              </h4>
                              <!-- <h4 class="title text-left">% Change from Dec-19</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumnsChange" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovidChange"
                                      :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumnsChange" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumnsChange[index]] ?
                                        element[yearsCovidColumnsChange[index]].Employment:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-size-100 blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">% Change from
                                  Dec-19 Sales
                                  (Dec-19={{ newCovidChange['Dec'] &&
                                  newCovidChange['Dec']['19'] ? newCovidChange['Dec']['19'].Sales:''}})
                                </div>
                              </h4>
                              <!-- <h4 class="title text-left">% Change from Dec-19</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumnsChange" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovidChange"
                                      :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumnsChange" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumnsChange[index]] ?
                                        element[yearsCovidColumnsChange[index]].Sales:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card header-animation="false" :chart-data="covidImpactChangeLineChart.data"
                                :chart-options="covidImpactChangeLineChart.options" chart-type="Bar" header-icon
                                chart-inside-content no-footer background-color="blue">
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Monthly
                                      Change Index (Dec-19=1.00)</div>
                                  </h4>
                                  <!-- <h4 class="title">Monthly Change Index (Dec-19=1.00)</h4> -->
                                </template>
                              </chart-card>

                              <div class="pie-line"
                                v-if="covidImpactChangeLineChart && covidImpactChangeLineChart.data && covidImpactChangeLineChart.data.series">
                                <ul>
                                  <li v-for="(label, index) in covidImpactChangeLineChart.data.series"
                                    :key="index + '_label'"><span class=""><i
                                        :class="'fa fa-square ' + 'chart-label-color-' + index"></i></span> {{
                                    label.name }}</li>

                                </ul>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <md-card class="md-card-profile px-4">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                <md-icon class="color-white">article</md-icon> Covid Impact
                              </div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100">
                                <div class="extra_space">
                                  <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                  </h4>-->
                                  <p>
                                    Bizminer reports now adjust our raw data to better reflect the most recent changes
                                    in local and
                                    national industry markets. We accomplish this by integrating additional Census
                                    Bureau data with
                                    our proprietary content, allowing us to accelerate and refine month-to-month trends.
                                    Our content
                                    displays the new data in three ways:
                                  <ul>
                                    <li> Our employment data is adjusted to better reflect the most
                                      recent realities at local and national levels </li>
                                    <li> Updates of industry market sales averages and total
                                      market volume are accelerated by one month and renamed as Trailing Twelve Month
                                      (TTM) values</li>
                                    <li> New content will display monthly (not annual) industry sales and employment
                                      from year-end 2019 through
                                      both Preliminary Update and Advance Projection months. </li>
                                  </ul>
                                  These enhanced protocols will be most obvious in
                                  our Industry Market Trend series, including a new "Monthly Change" tab in each report.
                                  Similarly,
                                  snapshot reports like the SWOT-XPRESS, Competitive Market Narrative and Company
                                  Insight series will
                                  reflect our new update protocols and add content for Preliminary Update and Advance
                                  months.
                                  Shorter projections are more detailed and accurate than longer-term projections.
                                  Preliminary Update
                                  data is calculated on a more accurate and detailed basis than the Advance Projection
                                  month, which will
                                  adjust as it moves to "update month" status the following month. Interpret and utilize
                                  this content accordingly.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from '@/components';
import { ChartCard, NavTabsCard } from "@/components";
import { mapActions, mapState } from 'vuex';
import MPHeader from './MPHeader';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    // Collapse,
    MPHeader
  },
  props: ['headerData'],
  data() {
    return {
      newCovid: [],
      monthsCovidColumns: [],
      yearsCovidColumns: [],
      newCovidChange: [],
      monthsCovidColumnsChange: [],
      yearsCovidColumnsChange: [],
      showDialog: false,
      tableDataMarketCovidImpact: [],
      tableDataMarketCovidImpactChange: [],
      covidImpactChangeLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      names: [],
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
      filtered_covid_info: [],
      filtered_covid_change_info: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      tableCompetitors: state =>  state.user.industryProfile.data?state.user.industryProfile.data['competitors']:[],
      annualSales: state =>  state.user.industryProfile.data?state.user.industryProfile.data['annualSales']:[],
      annualSalesCols: state =>  state.user.industryProfile.data?state.user.industryProfile['annualSalesCols']:[],
      years: state => state.user.industryProfile.years,
      release_years: state => state.user.industryProfile.general.release_years,
      bznaics_code: state => state.user.industryProfile.general.bznaics,
      sector_name: state => state.user.industryProfile.general.sector,
      industry_title: state => state.user.industryProfile.general.industry,
      release_display: state => state.user.industryProfile.general['release_display'],
      update_month: state => state.user.industryProfile.updateMonth,
      display_area: state => state.user.industryProfile.general.area_display_name,
      marketVolume: state =>  state.user.industryProfile.data?state.user.industryProfile.data['marketVolume']:[],
      marketShare: state =>  state.user.industryProfile.data?state.user.industryProfile.data['marketShare']:[],
      penetration: state =>  state.user.industryProfile.data?state.user.industryProfile.data['penetration']:[],
      employment: state =>  state.user.industryProfile.data?state.user.industryProfile.data['employment']:[],
      salesEmpSales: state =>  state.user.industryProfile.data?state.user.industryProfile.data['salesEmpSales']:[],
      salesEmpCols: state =>  state.user.industryProfile.data?state.user.industryProfile['salesEmpCols']:[],
      salesEmpEmployment: state =>  state.user.industryProfile.data?state.user.industryProfile.data['salesEmpEmployment']:[],
      productivity: state =>  state.user.industryProfile.data?state.user.industryProfile.data['productivityValues']:[],
      startupPerformance: state =>  state.user.industryProfile.data?state.user.industryProfile.data['startupsValues']:[],
      startupRates: state =>  state.user.industryProfile.data?state.user.industryProfile.data['startupsIndex']:[],
      cessation: state =>  state.user.industryProfile.data?state.user.industryProfile.data['cessation']:[],
      ownership: state => state.user.industryProfile.data? state.user.industryProfile.data['ownership']:[],
      demographics: state =>  state.user.industryProfile.data?state.user.industryProfile.data['demographics']:[],
      covid: state => state.user.industryProfile.data?state.user.industryProfile.data['covid']:[],
      covidColumns: state => state.user.industryProfile.data?state.user.industryProfile.data['covidColumns']:[],
      covidChange: state => state.user.industryProfile.data?state.user.industryProfile.data['covidChange']:[],
      covidChangeColumns: state => state.user.industryProfile.data?state.user.industryProfile.data['covidChangeColumns']:[],
    }),
    getCsvData() {
      let csvData = [
        [
          'Bizminer Local Industry Market Report',
        ],
        [
          this.bznaics_code, this.industry_title,
        ],
        [
          "Sector: " + this.sector_name,
        ],
        [
          this.display_area,
        ],
        [
          'Data Time Series', this.release_years.toString() + "-" + this.update_month
        ],
        [
          "Update Month", this.update_month,
        ],
        [""],
      ]
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
       if (e && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Annual Industry Market Volume($)"], ['as of:', this.years]);
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g,'');
          }
        });
        csvData.push(e);
      });
      csvData.push([""], ["Share(%)"], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (e && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], [""], ['Average Annual Sales']);
      csvData.push(["", this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
       if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Rank"], ['as of:', this.years]);
      csvData.push([""], [""], [""], [""], [""]);
      csvData.push(["Market Penetration ($)"]);
      csvData.push(["", this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (e && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], ["To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser"]);
      csvData.push([""], [""]);
      csvData.push(["Employment", this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (e && e.includes(',')) {
          e = e.replace(/,/g, '')
        }
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Market Volume by Employment Class", this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
       if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Percent Market Volume by Employment Class", this.years]);
      this.filtered_market_percent_by_class.forEach((e, i) => {
       if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Sales by Employment Class", this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
       if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Establishments by Employment Class", this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Total Employment by Class", this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Employment by Class", this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
       if (e && e.includes(',')) {
          e = e.replace(/,/g, '.')
        }
        csvData.push(e);
      });
      csvData.push([""], ["Productivity"]);
      csvData.push(["Annual Sales per Employee", this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Average Annual Wage", this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Rent per Employee", this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Productivity Indices (%)", this.years]);
      csvData.push([""], [""], [""], [""], [""]);
      csvData.push(["Startup Activity and Performance"]);
      csvData.push(["", this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""], [""]);
      csvData.push(["To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser"], [""], [""], [""], [""], ["Cessation Rates (2019-2020)"]);
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Ownership/Consolidation Trends", this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Market Area Demographic Highlights"]);
      csvData.push(["(based on zip codes co-joined with your market radius) (2015)"]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        })
        csvData.push([""]);
      });
      csvData.push([""], ["COVID IMPACT"], ["Month-to-Month Employment-Sales"]);
      csvData.push(["", this.covidColumns]);
      this.filtered_covid_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["% Change from Dec-19"]);
      csvData.push(["", this.covidChangeColumns]);
      this.filtered_covid_change_info.forEach((e, i) => {
        csvData.push(e);
      });
      return csvData;
    },
  },
  mounted() {
    this.buildEmploymentSalesDataMonthToMonth();
    this.buildEmploymentSalesDataChangeFromDec19();

    this.tableDataMarketCovidImpact = this.covidColumns.map((name, index) => ({ name, dates: Object.values(this.covid).map(item => item[index]) }));
    this.names = Object.keys(this.covid);
    this.tableDataMarketCovidImpactChange = Object.entries(this.covidChange).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.covidImpactChangeLineChart.data = {
      labels: this.covidChangeColumns,
      series: this.tableDataMarketCovidImpactChange.map(item => ({ name: item.name, data: item.dates.map(i => typeof i === 'string' ? Number(i.replace('%', '')) : i) }))
    };

    let populationData = Object.entries(this.tableCompetitors).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_population.push(r);
    })
    let marketVolume = Object.entries(this.marketVolume).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    let me = this;
    marketVolume.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      modifiedArr.push(r);
    })
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
        if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    })
    this.filtered_market_share = this.filtered_market_share.filter((item, index) => {
      return !item.includes("Your Firm");
    });
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    tableAnnual.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    })
    this.filtered_annual_sales = this.filtered_annual_sales.filter((item, index) => {
      if (!item.includes("Your Firm")) {
        return item;
      }
    });
    let penetrationData = Object.entries(this.penetration).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    penetrationData.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(([table, data]) => ({
      name: table,
      dates: Object.values(data)
    }));
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      })
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter((item, index) => {
      return !item.includes("Your Firm");
    });

    let marketVolumeByClass = this.salesEmpSales && this.salesEmpSales.marketVolume? Object.entries(this.salesEmpSales.marketVolume).map(([name, data]) => ({
      name,
      dates: data
    })): [];
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    })
    let marketPercentVolumeByClass = this.salesEmpSales && this.salesEmpSales.percentMarket? Object.entries(this.salesEmpSales.percentMarket).map(([name, data]) => ({
      name,
      dates: data
    })):[];
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    })
    let averageSaleByClass = this.salesEmpSales && this.salesEmpSales.average? Object.entries(this.salesEmpEmployment.average).map(([name, data]) => ({
      name,
      dates: data
    })):[];
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    })
    let establishmentByClass = this.salesEmpSales && this.salesEmpSales.establishments?Object.entries(this.salesEmpEmployment.establishments).map(([name, data]) => ({
      name,
      dates: data
    })):[];
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    })
    if(this.salesEmpEmployment && this.salesEmpEmployment.total){
    let totalEmploymentByClass = Object.entries(this.salesEmpEmployment.total).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    })
    let averageEmploymentByClass = Object.entries(this.salesEmpEmployment.average).map(([name, data]) => ({
      name,
      dates: data
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    })
    let annualSalesPerEmployee = Object.entries(this.productivity.spe).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter((item, index) => {
      return !item.includes("Your Firm");
    });
    let averageAnnualWage = Object.entries(this.productivity.annualWage).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter((item, index) => {
      return !item.includes("Your Firm");
    });
    let rentPerEmployee = Object.entries(this.productivity.rent).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter((item, index) => {
      return !item.includes("Your Firm");
    });
    let startupPerformance = Object.entries(this.startupPerformance).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    startupPerformance.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    startupRates.map(item => {
      item.dates = item.dates.map(e => {
        return me.numberWithPoints(e)
      })
      return item
    })
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let cessationRates = Object.entries(this.cessation).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      })
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });
    }
    let demographicInfo = Object.entries(this.demographics).map(([table, data]) => ({ name: table, data: Object.values(data) }));
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = []
      this.filtered_demographic_info[index].push([element.name])
      if (element.data.length > 1) {
        element.data.forEach((el, i) => {
          Object.keys(el).forEach(key => {
            let a = el[key];
            a = a.map(e => {
              if (e && e.includes(',')) {
                return me.numberWithPoints(e)
              } else {
                return e
              }
            })
            if (!a.includes(key)) {
              a.unshift(key)
            }
            this.filtered_demographic_info[index].push(a);
            this.filtered_demographic_info[index].push([""]);
          })
        })
      } else {
        element.data.forEach((el, i) => {

          Object.keys(el).forEach(key => {
            let a = el[key];
            a = a.map(e => {
             if (e && e.includes(',')) {
                return me.numberWithPoints(e)
              } else {
                return e
              }
            })
            if (!a.includes(key)) {
              a.unshift(key)
            }
            this.filtered_demographic_info[index].push(a);
          })
        })
      }
    })
    let covidData = this.covidColumns.map((name, index) => ({ name, dates: Object.values(this.covid).map(item => item[index]) }));
    covidData.map(item => {
      item.dates = item.dates.map(e => {
        if (e && e.includes(',')) {
          return me.numberWithPoints(e)
        } else {
          return e
        }
      })
      return item
    })
    let covidKeys = Object.keys(this.covid);
    covidKeys.forEach((element, index) => {
      let b = [];
      covidData.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_covid_info.push(b);
    })

    let covidChangedData = this.covidChangeColumns.map((name, index) => ({ name, dates: Object.values(this.covidChange).map(item => item[index]) }));
    covidChangedData.map(item => {
      item.dates = item.dates.map(e => {
        if (e && e.includes(',')) {
          return me.numberWithPoints(e)
        } else {
          return e
        }
      })
      return item
    })
    let covidChangedKeys = Object.keys(this.covid);
    covidChangedKeys.forEach((element, index) => {
      let b = [];
      covidChangedData.forEach((el, num) => {
        b.push(el.dates[index])
      })
      b.unshift(element);
      this.filtered_covid_change_info.push(b);
    })
  },

  methods: {
    ...mapActions({
      registerProductExport: 'tracking/registerProductExport',
    }),
    groupBy: function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || [])[x.year] = x;
        return rv;
      }, {});
    },
    buildEmploymentSalesDataMonthToMonth: function () {
      let i = 0;
      let covidAux = this.covidColumns;
      this.newCovid = covidAux.map(item => {
        let aux = {
          Employment: this.covid.Employment[i],
          Sales: this.covid['Average Monthly Site Sales'][i],
          month: item.split('-')[0],
          year: item.split('-')[1],
          monthOrder: this.checkMonth(item.split('-')[0],),
        }
        i++;
        return aux;
      });

      this.newCovid.forEach(item => {
        this.monthsCovidColumns.push({ month: item.month, index: this.checkMonth(item.month) })
        if(item.year !=19)
          this.yearsCovidColumns.push(item.year)
      })

      this.yearsCovidColumns = this.yearsCovidColumns.filter((el, i) => this.yearsCovidColumns.indexOf(el) === i);

      this.monthsCovidColumns = this.monthsCovidColumns.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))


      this.newCovid.sort((a, b) => a.monthOrder - b.monthOrder);

      this.newCovid = this.groupBy(this.newCovid, 'month')

      Object.keys(this.newCovid).forEach((index, item) => {
        for (let i = 0; i < this.yearsCovidColumns.length; i++) {
          if (!this.newCovid[index][this.yearsCovidColumns[i]]) {
            this.newCovid[index][this.yearsCovidColumns[i]] = {
              Employment: '',
              Sales: '',
              year: this.yearsCovidColumns[i],
              month: index,
            }
          }
        }
      })
    },
    buildEmploymentSalesDataChangeFromDec19: function () {
      let i = 0;
      let covidAux = this.covidChangeColumns;
      this.newCovidChange = covidAux.map(item => {
        let aux = {
          Employment: this.covidChange.Employment[i],
          Sales: this.covidChange['Average Monthly Site Sales'][i],
          month: item.split('-')[0],
          year: item.split('-')[1],
          monthOrder: this.checkMonth(item.split('-')[0],),
        }
        i++;
        return aux;
      });

      this.newCovidChange.forEach(item => {
        this.monthsCovidColumnsChange.push({ month: item.month, index: this.checkMonth(item.month) })
        if(item.year !=19)
          this.yearsCovidColumnsChange.push(item.year)
      })

      this.yearsCovidColumnsChange = this.yearsCovidColumnsChange.filter((el, i) => this.yearsCovidColumnsChange.indexOf(el) === i);

      this.monthsCovidColumnsChange = this.monthsCovidColumnsChange.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))


      this.newCovidChange.sort((a, b) => a.monthOrder - b.monthOrder);

      this.newCovidChange = this.groupBy(this.newCovidChange, 'month')

      Object.keys(this.newCovidChange).forEach((index, item) => {
        for (let i = 0; i < this.yearsCovidColumnsChange.length; i++) {
          if (!this.newCovidChange[index][this.yearsCovidColumnsChange[i]]) {
            this.newCovidChange[index][this.yearsCovidColumnsChange[i]] = {
              Employment: '',
              Sales: '',
              year: this.yearsCovidColumnsChange[i],
              month: index,
            }
          }

        }
      })
    },
    checkMonth: function (month) {
      switch (month) {
        case 'Jan':
          return 1;
        case 'Feb':
          return 2;
        case 'Mar':
          return 3;
        case 'Apr':
          return 4;
        case 'May':
          return 5;
        case 'Jun':
          return 6;
        case 'Jul':
          return 7;
        case 'Aug':
          return 8;
        case 'Sep':
          return 9;
        case 'Oct':
          return 10;
        case 'Nov':
          return 11;
        case 'Dec':
          return 12;
      }
    },
     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
      this.registerProductExport({
          userId: this.user?.userID,
          productId: this.$route.params.id,
          exportType: 'CSV'
      })
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
